export default class NetworkPluvioLinkDto {
    constructor(obj) {
        this.idPluviometer = obj.idStation
        this.idNetwork = obj.idNetwork
        this.startDate = obj.startDate
        this.endDate = obj.endDate
    }
}